class FundingObligationImportResultModalController {
  constructor($uibModalInstance, title, summary, errors) {
    'ngInject';
    this.$uibModalInstance = $uibModalInstance;
    this.title = title || 'Import Result';
    this.summary = summary || '';
    this.errors = errors || [];
  }

  close() {
    this.$uibModalInstance.close();
  }
}

export default FundingObligationImportResultModalController;



// WEBPACK FOOTER //
// ./client/common/modals/fundingObligationImportResultModal/fundingObligationImportResultModal.controller.js